import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	Output
} from '@angular/core';
import { FileUploadServiceProvider } from '../../../../../../shared/services/files/file-upload-service/file-upload.service';
import { MessageService } from '../../../../../../shared/services/helpers/message-service/message.service';
import { Subject } from 'rxjs/Subject';
import { IFilesObj } from '../../../../../../shared/models/models';

@Component({
	selector: 'web-attachments',
	template: require('./attachments.component.html')
})
export class WebAttachmentsComponent implements OnDestroy, OnChanges {
	@Input() attachmentId: string;
	@Input() filesObj: any;
	@Output()
	attachmentsChanged: EventEmitter<IFilesObj> = new EventEmitter<IFilesObj>();
	files: any = null;

	attachmentsView: Array<any> = [];
	unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private fileUploadService: FileUploadServiceProvider,
		private messageService: MessageService
	) {}

	ngOnChanges() {
		if (this.filesObj !== undefined) {
			this.attachmentsView = this.filesObj.attachments;
			this.handleAttachmentsView(this.attachmentsView);
		}
	}

	ngOnDestroy() {
		this.unsubscribe.next();
	}

	renewFiles(event): void {
		if (event && event.target.files) {
			let newFile = event.target.files[0];
			newFile = this.fileUploadService.addFileConvertedSize(newFile);
			this.attachmentsView.push(newFile);
			this.handleAttachmentsView(this.attachmentsView, newFile);
		}
	}

	removeAttachment(index): void {
		this.attachmentsView.splice(index, 1);
		this.handleAttachmentsView(this.attachmentsView);
	}

	private handleAttachmentsView(attachmentsView, newFile?): void {
		if (attachmentsView && attachmentsView.length > 0) {
			const resultSize = this.fileUploadService.getTotalSize(attachmentsView);
			const maxSize: number = this.fileUploadService.maxAttachment;

			if (resultSize > maxSize) {
				this.messageService.showToaster('w_0', 'attachments');
				if (typeof newFile !== 'undefined') {
					attachmentsView.pop(newFile);
					return;
				}
			}

			if (this.filesObj === undefined) {
				this.filesObj = <IFilesObj>{};
			}

			this.filesObj.filesSize = resultSize;
			this.filesObj.attachments = attachmentsView;
			this.attachmentsChanged.emit(this.filesObj);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/sn-quill-editor/attachments/attachments.component.ts